import { useTranslation } from 'react-i18next';

const steps = [
  { icon: 'ri-sun-foggy-line' },
  { icon: 'ri-sun-line' },
  { icon: 'ri-restaurant-2-line' },
  { icon: 'ri-moon-line' },
];

function renderParagraphs(text: string, className: string) {
  return text.split(/(?:\r?\n){2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function DayFlow() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-8 md:px-12">
        <div className="text-center mb-14">
          {renderParagraphs(
            t('butlerJob.day.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerJob.day.title')}
          </h2>
          {renderParagraphs(
            t('butlerJob.day.titleEn'),
            'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4',
          )}
          <div className="gold-line mx-auto mb-6"></div>
          {renderParagraphs(
            t('butlerJob.day.lead'),
            'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[680px] mx-auto',
          )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-10 items-start">
          <ol className="relative border-l border-accent-500/25 pl-8 space-y-9 list-none">
            {steps.map((step, idx) => (
              <li key={idx} className="relative">
                <div className="absolute -left-[49px] top-0 w-[34px] h-[34px] rounded-full bg-primary-900 border border-accent-500/40 flex items-center justify-center">
                  <i className={`${step.icon} text-accent-400 text-[15px]`}></i>
                </div>
                {renderParagraphs(
                  t(`butlerJob.day.${idx}.time`),
                  'text-accent-600 text-[13px] tracking-[0.16em] mb-1.5 font-label',
                )}
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2.5">
                  {t(`butlerJob.day.${idx}.title`)}
                </h3>
                {renderParagraphs(
                  t(`butlerJob.day.${idx}.desc`),
                  'text-[16px] text-foreground-600 tracking-[0.04em] leading-[1.9]',
                )}
              </li>
            ))}
          </ol>

          <figure className="lg:sticky lg:top-28">
            <div className="relative w-full aspect-[4/3] overflow-hidden border border-background-200/60">
              <img
                src="/images/generated/roleplay-daily-2026.jpg"
                alt={t('butlerJob.day.imgAlt')}
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
            </div>
            <figcaption className="text-[13px] text-foreground-400 tracking-[0.04em] mt-3">
              {t('butlerJob.day.imgCaption')}
            </figcaption>
          </figure>
        </div>

        {renderParagraphs(
          t('butlerJob.day.note'),
          'text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mt-12 pt-6 border-t border-background-200/60',
        )}
      </div>
    </section>
  );
}
